var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"float":"left","margin-top":"15px"}},_vm._l((_vm.svgs),function(svg){return _c('img',{key:svg,staticClass:"icon",attrs:{"src":svg},on:{"click":function($event){return _vm.svgSelected(svg)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }